import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  atividades: {
    showAdvancedSearch: false,
    advancedSearchParams: {},
  },
  procedimentos: {
    showAdvancedSearch: false,
    advancedSearchParams: {},
  },
  livrosFiscais: {
    showAdvancedSearch: false,
    advancedSearchParams: {},
  },
  procedimentoFiscal: {
    showAdvancedSearch: false,
    advancedSearchParams: {},
  },
  tipoOcorrencia: {
    showAdvancedSearch: false,
    advancedSearchParams: {},
  },
  tipoOcorrenciaOs: {
    showAdvancedSearch: false,
    advancedSearchParams: {},
  },
  tipoParteServico: {
    showAdvancedSearch: false,
    advancedSearchParams: {},
  },
  executarOs: {
    showAdvancedSearch: false,
    advancedSearchParams: {},
    titleBarParams: {
      codUsuario: null,
      codAcao: 0,
      isTimer: 0,
      pageNumber: null,
      selectValue: null,
    },
  },
  parteServico: {
    showAdvancedSearch: false,
    advancedSearchParams: {},
  },
};

const paginatedViewSlice = createSlice({
  name: "paginatedView",
  initialState,
  reducers: {
    saveParams(state, action) {
      if (state[action.payload.reduxKey] === undefined) state[state.payload.reduxKey] = {};
      state[action.payload.reduxKey].advancedSearchParams = { ...action.payload.params };
    },
    setShowAdvancedSearch(state, action) {
      if (state[action.payload.reduxKey] === undefined) state[state.payload.reduxKey] = {};
      state[action.payload.reduxKey].showAdvancedSearch = action.payload.showAdvancedSearch;
    },
    setTitleBarParams(state, action) {
      if (state[action.payload.reduxKey] === undefined) state[state.payload.reduxKey] = {};

      Object.keys(action.payload.titleBarParams).forEach((key) => {
        state[action.payload.reduxKey].titleBarParams[key] = action.payload.titleBarParams[key];
      });
    },
  },
});

export const paginatedViewActions = paginatedViewSlice.actions;

export default paginatedViewSlice.reducer;
